// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"Z6-z"};